// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'view-design/dist/styles/iview.css';
import iView from 'view-design';
import Vue from 'vue';
import Vuex from 'vuex';
import VueResource from 'vue-resource';
import App from './App';
import EventBus from './event_bus';
import router from './router';

// 引入 Element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(Vuex);
Vue.use(VueResource);
Vue.use(iView);
// 使用 Element UI
Vue.use(ElementUI);

Vue.config.productionTip = false;

// 动态设置API根地址
// 首先尝试从window全局配置获取，否则使用相对路径
const apiRoot = window.APP_CONFIG && window.APP_CONFIG.apiRoot ? window.APP_CONFIG.apiRoot : '/api/v1';
Vue.http.options.root = apiRoot;

// 获取后端配置
function fetchBackendConfig() {
  // 使用原生fetch来获取初始配置，避免Vue实例未准备好的问题
  return fetch('/api/v1/config').then((res) => {
    return res.json();
  }).then((data) => {
    const cfg = data && data.data ? data.data : {};
    if (cfg.baseUrl) {
      // 使用后端返回的baseUrl
      Vue.http.options.root = cfg.baseUrl + '/api/v1';
      console.log('API root set to:', Vue.http.options.root);
    }
  }).catch((err) => {
    console.warn('Failed to fetch backend config, using default:', err);
  });
}

Vue.http.interceptors.push(function (request, next) {
  request.credentials = true; // 允许发送cookie

  this.$Loading.start();

  next(function (response) {
    // 处理http请求异常
    const data = response.data;
    if (data && data.code > 0) {
      this.$Message.warning({
        content: data.message || '后台未知错误',
        duration: 5
      });
      this.$Loading.error();
    } else if (response && response.status !== 200) {
      let message = response.statusText;
      switch (response.status) {
        case 404:
          message = '页面或接口不存在!';
          break;
        case 500:
          message = '服务器内部错误!';
          break;
        default:
          break;
      }
      this.$Message.warning({
        content: message || '后台未知错误',
        duration: 5
      });
      this.$Loading.error();
    } else {
      this.$Loading.finish();
    }
  });
});

const store = new Vuex.Store({
  state: {
    user: {
      userInfo: null,
      roles: [],
      permissions: []
    }
  },
  mutations: {
    /* eslint-disable */
    clearUser(state) {
      state.user.userInfo = null;
      state.user.roles = [];
      state.user.permissions = [];
    },
    updateUser(state, data) {
      if (data.id && data.username) {
        state.user.userInfo = {
          id: data.id,
          username: data.username
        };
        state.user.roles = data.roles || [];
        state.user.permissions = data.permissions || [];
      }
    }
  }
});

router.beforeEach((to, from, next) => {
  const path = to.path.substr(1);
  const pathPermission = path.split('/').join(':');
  const permissions = store.state.user.permissions || [];
  if (permissions.indexOf(pathPermission) < 0) {
    // 禁止访问无权限页面
    next(false);
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  EventBus.$emit('route-change', {
    to: to,
    from: from
  });
});

// 获取配置后启动应用
fetchBackendConfig().then(() => {
  new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App },
  });
}).catch(() => {
  // 如果获取配置失败，仍然启动应用
  new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App },
  });
});
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/main.js